import Library from '../utility/Library';
import Entity from './Entity';
import Status from './Status';
import Reader from './blueprint/Reader';

export default class Player extends Entity {

	constructor (master) {

		super();
		this.master = master;
		this.champion = master.run.champion;
	}

	init () {

		if (this.champion.model.passive)
			Reader.read(this.champion.model.passive.blueprint, this);
		let tmpevents = this.events;
		delete this.events;
		if (this.champion.companion && this.champion.companion.skill)
			Reader.read(this.champion.companion.skill.blueprint, this);
		this.skills = this.events;
		this.events = tmpevents;
		this.champion.relics.forEach(relic => {
			if (relic.blueprint)
				Reader.read(relic.blueprint, this);
		});
	}

	get hp () { return this.champion.hp }
	get maxhp () { return this.champion.maxhp }

	get img () {

		if (this.hasStatus('facing-back'))
			return this.champion.backimg;
		return this.champion.img;
	}

	get id () {

		return "player";
	}

	get isPlayer () { return true; }

	get model () {

		return this.champion.model;
	}

	get companion () {

		return this.master.companion;
	}

	grow (n=1) {

		this.events = [];
		if (this.champion.model.passive) {
			for (let i = 0; i < n; i++)
				Reader.read(this.champion.model.passive.growth, this);
			this.events.forEach(e => e());
		}
	}

	shrink (n=1) {

		this.events = [];
		if (this.champion.model.passive) {
			for (let i = 0; i < n; i++)
				Reader.read(this.champion.model.passive.shrinkage, this);
			this.events.forEach(e => e());
		}
	}

	heal (amt) {

		this.champion.heal(amt);
	}

	loseLife (amt, src) {

		this.champion.loseLife(amt);
		
		if (this.hp <= 0)
			this.die();
	}

	get spentSkill () {

		return this.champion.companion && (this.hasStatus("turn-ended") || this.skilllock || this.skillCooldown && this.skillCooldown > this.champion.getPassive("extraskills"));
	}

	get canUseSkill () {

		if (!this.champion.companion)
			return false;
		const companion = this.champion.companion;
		if (!companion.model.skill)
			return false;
		if (this.spentSkill)
			return false;
		if (!this.champion.getPassive("freeskill") && companion.model.skill.mana > this.master.mana)
			return false;
		if (this.master.choosingHand)
			return false;
		return true;
	}

	useSkill (pay=true) {

		if (this.hasStatus("turn-ended"))
			return;

		if (pay && !this.champion.getPassive("freeskill"))
			this.master.pay(this.champion.companion.model.skill.mana);
		this.skillCooldown = (this.skillCooldown || 0) + 1;
		this.triggerSkill(true);
	}

	triggerSkill (consumeUse=false) {

		this.master.notify("skill.before", this, consumeUse);
		if (this.skills) {
			this.skills.forEach(e => e());
		}
		this.master.notify("skill", this);
	}

	lockSkill () {

		this.skilllock = true;
		this.master.notify("lockskill", this);
	}

	die () {

		super.die();
		this.master.lose();
	}

	update () {

		super.update();
		delete this.skilllock;
	}

	serialize () {

		return {
			key: this.key,
			block: this.block,
			statuses: this.statuses.map(status => status.serialize()),
			skillCooldown: this.skillCooldown,
			skilllock: this.skilllock
		}
	}

	static build (master, src, init) {

		let player = new Player(master);
		if (init)
			player.init();
		player.block = src.block;
		player.statuses = src.statuses.map(status => Status.build(master, player, status)).filter(status => !status.dissipated);
		player.skillCooldown = src.skillCooldown;
		player.skilllock = src.skilllock;
		return player;
	}
}
